<!--
 Created by huangw on 2020/10/16.
 仪表盘组件
-->
<template>
  <div :id="id" :style="style"></div>
</template>

<script>
import echarts from "echarts";
import Vue from "vue";
Vue.prototype.$echarts = echarts;
export default {
  name: "echar",
  props: {
    id: {
      type: String,
    },
    style: {},
  },
  data() {
    return {
      myChart: null,
    };
  },
  mounted() {
    this.drawLine();
  },
  created() {
    const user = this.$ls.get("user");
  },
  beforeDestroy() {},
  methods: {
    refreshData(legend, grid, xAxis, series) {
      this.myChart.showLoading();
      var option = this.myChart.getOption();
      option.legend = legend;
      option.grid = grid;
      option.xAxis = xAxis;
      option.series = series;

      this.myChart.setOption(option);
      this.myChart.hideLoading();
    },
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(document.getElementById(this.id));
      // 绘制图表
      this.myChart.setOption({
        tooltip: {
          formatter: "{a}: <br/> {c}",
        },
        // toolbox: {
        //   feature: {
        //     restore: {},
        //     saveAsImage: {},
        //   },
        // },
        series: [
          {
            name: "平均待办时长",
            type: "gauge",
            detail: { formatter: "{value}" },
            data: [{ value: 0, name: "" }],
          },
        ],
        // grid: {
        //   width:300,
        //   height:300
        // },
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>
